import { HttpClient } from "@angular/common/http"
import { inject, Injectable } from "@angular/core"
import { Observable, of } from "rxjs"
import { catchError } from "rxjs/operators"
import { AppRedirectConfig } from "@core/models/app-config.model"
import { EnvironmentService } from "../environment/environment.service"

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private readonly http = inject(HttpClient)
  private readonly environment = inject(EnvironmentService)

  private readonly API_URL = this.environment.getApiUrl()

  /**
   * Obtiene la configuración global de redirección de la app.
   * Si el endpoint no existe, falla o retorna error, devuelve null
   * y la app continúa con su flujo normal.
   */
  getRedirectConfig(): Observable<AppRedirectConfig | null> {
    return this.http
      .get<AppRedirectConfig>(`${this.API_URL}v1/app-frontend-config`)
      .pipe(catchError(() => of(null)))
  }
}
